/**
 * Thin wrapper that mounts ComparisonView inside the evaluation detail
 * shell. All comparison UI — ComparisonOverview / Details / Scoring /
 * Financials / Risks / ProsCons / Map plus the SiteMultiPicker and
 * ComparisonTabs — lives in `components/comparison/` (F1–F6).
 *
 * Linear: MYD-222 (F7).
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import ComparisonView from './comparison/ComparisonView'

const EvaluationCompare = () => {
	const { evalId } = useOutletContext<EvaluationOutletContext>()
	return <ComparisonView evalId={evalId} />
}

export default EvaluationCompare
